import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { SmsMfaVerification } from '../shared/model/sms-mfa-verification.model';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from '../service/authentication.service';
import { UtilService } from '../service/util.service';
import { ToastService } from '../service/toast.service';
import { Constants } from '../constants/constants';
import { Router } from '@angular/router';

@Component({
  selector: 'sms-mfa-verification',
  templateUrl: './sms-mfa-verification.component.html',
  styleUrls: ['./sms-mfa-verification.component.scss']
})
export class SmsMfaVerificationComponent implements OnInit, OnChanges {

  @Input() smsMfaData;
  @Output() resendMfaErrorEmitter: EventEmitter<any> = new EventEmitter<any>();
  smsMfaVerificationModel: SmsMfaVerification = new SmsMfaVerification();
  smsMfaVerificationForm: NgForm;
  mfaFormLabel = Constants.MFA_FORM_LABEL;
  mfaFormMessage = Constants.MFA_FORM_MESSAGE;
  mfaFormMessageTimeLimit = Constants.MFA_FORM_MESSAGE_TIME_LIMIT;

  constructor(private authService: AuthenticationService, private utilService: UtilService, private toast: ToastService, private router: Router) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("smsMfaData", this.smsMfaData);
    this.initUserVerificationModel();
  }

  initUserVerificationModel() {
    this.smsMfaVerificationModel.username = this.smsMfaData.username;
    this.smsMfaVerificationModel.session = this.smsMfaData.session;
    console.log("SMS MFA VerificationModel::", this.smsMfaVerificationModel);
  }

  formSubmit(form: NgForm): void {
    this.smsMfaVerificationForm = form;
    if (form.valid) {
      console.log("userVerificationModel::", this.smsMfaVerificationModel);
      this.validateMfa();
    }
  }

  validateMfa() {
    this.utilService.showSpinner();
    this.authService.validateMfa(this.smsMfaVerificationModel).then(() => {
      this.utilService.hideSpinner();
      console.log("Verification done");
      if (this.smsMfaVerificationForm) {
        this.smsMfaVerificationForm.reset();
        this.smsMfaVerificationForm.resetForm();
      }
      this.smsMfaVerificationModel = new SmsMfaVerification();
    }).catch((error) => {
      console.log("mfa error::", error);
      this.utilService.hideSpinner();
      if (error && error.challengeParameters) {
        this.smsMfaVerificationModel.username = error.challengeParameters.USER_ID_FOR_SRP;
        this.smsMfaVerificationModel.session = error.session;
        this.toast.showError(Constants.INVALID_VERIFICATION_CODE);
      } else if (error && error.error && error.error.errorCode == Constants.AUTH_401101) {
        this.toast.showError(Constants.MFA_WRONG_CODE_LIMIT_EXCEED);
        this.showLoginView();
      } else if (error && error.error && error.error.errorCode == Constants.AUTH_401102) {
        this.toast.showError(Constants.MFA_VERIFY_CODE_SESSION_TIMEOUT);
        this.showLoginView();
      } else {
        this.toast.showError(error && error.error && error.error.message ? error.error.message : Constants.UNKNOWN_ERROR);
      }
    });
  }

  resendMFACode() {
    var paylaod = {
      "username": this.smsMfaVerificationModel.username,
      "session": this.smsMfaVerificationModel.session
    };
    console.log("Resend code : ", paylaod);
    this.getMFACode(paylaod);
  }

  getMFACode(payload) {
    this.utilService.showSpinner();
    this.authService.resendMFACode(payload).then((data) => {
      this.utilService.hideSpinner();
      console.log("getMFACode data : ", data);
      if (data) {
        this.smsMfaVerificationModel.username = data.challengeParameters.USER_ID_FOR_SRP;
        this.smsMfaVerificationModel.session = data.session;
        this.toast.showSuccess(this.mfaFormMessage + " " + data.challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM + " on " + data.challengeParameters.CODE_DELIVERY_DESTINATION);
      }
    }).catch((error) => {
      this.utilService.hideSpinner();
      console.log("error :: ", error);
      if (error && error.error && error.error.errorCode == Constants.AUTH_401101) {
        this.toast.showError(Constants.MFA_CODE_RESEND_LIMIT_EXCEED);
        this.showLoginView();
      } else if (error && error.error && error.error.errorCode == Constants.AUTH_401102) {
        this.toast.showError(Constants.MFA_RESEND_CODE_SESSION_TIMEOUT);
        this.showLoginView();
      } else {
        this.toast.showError(error && error.error && error.error.message ? error.error.message : Constants.UNKNOWN_ERROR);
      }
    });
  }

  showLoginView() {
    setTimeout(() => {
      this.resendMfaErrorEmitter.emit();
    }, 1000);
  }
}
